<template>
  <div>
    winter rider
  </div>
</template>

<script>
export default {
  name: 'WinterRiderPage',
}
</script>
